import makeErrorCause from 'make-error-cause';

export const UnconfirmedEmailError = makeErrorCause('UnconfirmedEmailError');
export const UnauthorizedError = makeErrorCause('UnauthorizedError');
export const WrappedError = makeErrorCause('WrappedError');
